import Vue from 'vue'
import Vuex from 'vuex'
import { isWeixin } from '@/utils/wechat'
import { getJson, getAccess, findLimit } from '@/service'
import { axios } from '@/service/config'
import { GetRole, GetAvailableAuditor } from '@/service/ticket'
import {
    getMemberInfo,
    getBookmarks,
    getMembershipLevelSettings
} from '../service/member'
import { LS_WECHAT_USER_INFO_KEY } from '@/configs/constants'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        userInfo: {},
        fileData: {},
        memberInfo: {},
        bookMarks: [],
        role: {},
        auditor: {},
        levelSettings: [],
        access: null
    },
    mutations: {},
    actions: {
        async getAuditor({ state }, { projectId, role }) {
            if (!state.auditor[projectId]) {
                state.auditor[projectId] = {}
            }
            if (!state.auditor[projectId][role]) {
                state.role[projectId][role] = await GetAvailableAuditor(
                    projectId,
                    role
                )
            }
            return state.role[projectId][role]
        },
        async getRole({ state }, projectId) {
            if (!state.role[projectId]) {
                state.role[projectId] = await GetRole(projectId)
            }
            return state.role[projectId] || {}
        },
        async isStaff({ dispatch }, projectId) {
            const { role } = await dispatch('getRole', projectId)
            return role === 'Staff'
        },
        async setInfo({ dispatch, state }) {
            await dispatch('getUserInfo')
            dispatch('getMemberInfo')
            dispatch('getLevelSettings')
            localStorage.setItem(LS_WECHAT_USER_INFO_KEY, JSON.stringify(state.userInfo))
        },
        async checkAccess({ state, dispatch }) {
            if (state.access != null) return state.access
            let isValid = false,
                freeLogin = false
            let { detail } = await findLimit()
            if (!(detail && Object.keys(detail).length)) {
                detail = {
                    wechatLimit: 'userinfo',
                    notWechatLimit: 'userinfo'
                }
            }
            if (isWeixin()) {
                switch (detail.wechatLimit) {
                    case 'userinfo':
                        window.cw('login_scope', 'snsapi_userinfo')
                        break
                    case 'base':
                        window.cw('login_scope', 'snsapi_base')
                        break
                    case 'nothing':
                        freeLogin = true
                }
            } else {
                switch (detail.notWechatLimit) {
                    case 'userinfo':
                        window.cw('login_scope', 'snsapi_userinfo')
                        window.cw('allowScanLogin', 1)
                        break
                    case 'base':
                        window.cw('login_scope', 'snsapi_base')
                        break
                    case 'nothing':
                        freeLogin = true
                }
            }
            if (freeLogin) {
                isValid = true
            } else {
                await dispatch('getUserInfo')
                const data = await getAccess()
                if (data.code == 200) {
                    isValid = true
                    // 通过
                } else if (data.code == 302) {
                    // 需要填表 redirect
                    window.location.replace(data.redirect)
                } else if (data.code == 306) {
                    // 需要关注 mpQrCode
                } else if (data.code == 403) {
                    // 需要成为会员
                    const { VUE_APP_FORM, VUE_APP_MEMBER_FORMID } = window.env
                    const redirect = VUE_APP_FORM + VUE_APP_MEMBER_FORMID
                    if (redirect) {
                        window.location.href = redirect
                    }
                } else {
                    // 黑名单...
                }
            }
            return (state.access = isValid)
        },
        getUserInfo({ state }, autoLogin = true) {
            return new Promise(async (resolve, reject) => {
                if (state.userInfo.openid) {
                    return resolve(state.userInfo)
                }
                window.cw(
                    'info',
                    info => {
                        state.userInfo = info
                        resolve()
                    },
                    () => {
                        if (autoLogin) {
                            window.cw('login')
                        }
                    }
                )
            })
        },
        async getJson({ state, dispatch }, file) {
            const fileName = file.slice(file.lastIndexOf('/') + 1)
            if (!state.fileData[fileName]) {
                let url
                if (/^(https?:)?\/\//.test(file)) {
                    url = await dispatch('getSignatureUrl', file)
                } else {
                    url = window.env.VUE_APP_DATA + file + '.json'
                }
                const data = await getJson(url)
                if (Array.isArray(data)) {
                    state.fileData[fileName] = data
                }
            }
            return JSON.parse(JSON.stringify(state.fileData[fileName]))
        },
        async getSignatureUrl({ state }, file) {
            let url
            if (/download\.(cloud|beta)\.custouch\.com/.test(file)) {
                url = await axios(file + '?view=2')
            } else {
                url = file
            }
            return url
        },
        async getMemberInfo({ state }) {
            try {
                state.memberInfo = await getMemberInfo()
                state.bookMarks = state.memberInfo.bookmarks
                return state.memberInfo
            } catch (error) {
                state.memberInfo = {}
            }
        },
        async getBookmarks({ state }, force = false) {
            if (force || !state.bookMarks || state.bookMarks.length === 0) {
                state.bookMarks = (await getBookmarks()).data
            }
            return state.bookMarks
        },
        // 获取申请表单
        async getLevelSettings({ state }, level) {
            const settings = await getMembershipLevelSettings()
            state.levelSettings = settings.map(
                item => item.memberApplicationSetting
            )
            if (level != null) {
                const currentLevel = state.levelSettings[level - 1]
                if (currentLevel && currentLevel.formIds[0]) {
                    return {
                        formId: currentLevel.formIds[0],
                        levelName: currentLevel.membershipLevel.levelName
                    }
                }
                return null
            }
            state.levelSettings.forEach(item => {
                if (item.formIds.length > 0) {
                    return {
                        formId: item.formIds[0],
                        levelName: item.membershipLevel.levelName
                    }
                }
            })
            return null
        }
    }
})
